<script setup lang="ts">
import {toRef} from "vue";

const props = defineProps({
    type: {
        type: String,
        default: "text",
    },
    value: {
        type: String,
        default: "",
    },
    modelValue: {
        type: String,
        default: "",
        required: false,
    },
    name: {
        type: String,
        required: true,
    },
    error: {
        type: String,
        default: null,
    },
    successMessage: {
        type: String,
        default: "",
    },
    placeholder: {
        type: String,
        default: "",
    },
    maxLength: {
        type: Number,
        default: null,
    },
});

const emit = defineEmits(["update:modelValue"]);

const name = toRef(props, "name");

const onHandlerChange = ($event) => {
    emit("update:modelValue", props.value);
};
</script>

<template>
    <textarea
        :name="name"
        :id="name"
        :type="type"
        :value="props.modelValue"
        class="form-control"
        :class="{'is-invalid': !!error}"
        :placeholder="placeholder"
        @input="emit('update:modelValue', $event.target.value)"></textarea>
    <span
        class="invalid-feedback"
        role="alert"
        v-show="error">
        {{ error }}
    </span>
</template>
